<template>
  <div v-if="team.id === 194"
       class="mb-4"
       style="border: 1px solid gray; width: 100%; padding: 8px;">
    <h4>
      Allergan's Email Template Naming Conventions
    </h4>
    <img src="https://teams.mobilelocker.com/allergan_aesthetics/assets/MLD-4912/allergan_email_template_naming_convention.png"
         alt="Allergan Email Template Naming Convention"/>
    <div>
      BTS will enforce this naming convention. Contact <a href="mailto:mobilelockersupport@abbvie.com?subject=Email%20Template%20Naming%20Convention" target="_blank">mobilelockersupport@abbvie.com</a> if you need help.
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'team',
    ])
  }
}
</script>
